import React, { lazy, Suspense } from "react";

// The Hero section should load immediately
import Benner from "../components/Benner";
import Hero from "../components/Hero.jsx";

// Lazy load below-the-fold sections for maximum performance
const Partners = lazy(() => import("../components/Partners"));
const NewArrival = lazy(() => import("../pages/products/NewArrival"));
const Aslider = lazy(() => import("../components/Animation.jsx"));
const WhyChoos = lazy(() => import("../components/WhyChoos"));
const WatchAndShop = lazy(() => import("../components/reels/Reel.jsx"));
const Testimonials = lazy(() => import("../components/Testimonials.jsx"));
const Blog = lazy(() => import("../components/Blog.jsx"));


// A simple loading placeholder for smooth transitions
const SectionLoader = () => (
  <div className="w-full h-[200px] flex items-center justify-center opacity-50">
    <div className="w-8 h-8 border-4 border-[#F36F21] border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const Home = () => {
  return (
    <>
      {/* <Hero /> */}
      
      <Benner />
      <Partners />
      <Suspense fallback={<SectionLoader />}>
        
        <NewArrival />
        <Aslider />
        <WhyChoos />
        <WatchAndShop />
        <Testimonials />
        <Blog />
      
      </Suspense>
    </>
  );
};

export default Home;
